import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ResponseModel } from '../domain/authentication.model'
import { CoreEnvironmentService } from './core-environment.service'

@Injectable({
  providedIn: 'root'
})
export class RegisterBeatmakerAccountService {
  baseUrl: string

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  createAccount(name: string): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(
      `${this.baseUrl}/beatmakers/beatmakers/RegisterAccount`,
      {
        name
      },
      { withCredentials: true }
    )
  }
}
